var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.btn_status in _vm.BD)?_c('wg-button',{class:_vm.status_cls,attrs:{"text":_vm.clickable
      ? _vm.button_get_text
      : _vm.btn_status == _vm.BS.STATUS_RECEIVED
      ? _vm.button_got_text
      : _vm.button_expires_text,"width":_vm.width,"height":_vm.height,"type":_vm.button_type,"font":{ fontSize: _vm.font },"main":_vm.button_main},nativeOn:{"click":function($event){return _vm.buttonClick.apply(null, arguments)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }